export enum Brands {
    retailcrm = 'retailcrm',
    simla = 'simla'
}
